import React from 'react';

import { AvatarIcon } from '@infoods/lifebase-ui';

import classes from './HostInfo.module.scss';

type HostInfoProps = {
  hostName: string;
  avatarUrl?: string;
};

const HostInfo = ({ hostName, avatarUrl }: HostInfoProps) => {
  return (
    <div className={classes.container}>
      <AvatarIcon userName={hostName} avatarImgLink={avatarUrl} size="small" />
      <div className={classes.titleBlock}>
        <p className={classes.title}>Host</p>
        <p className={classes.description}>{hostName}</p>
      </div>
    </div>
  );
};

export { HostInfo };
